/**
 * useCanvasRotation - Manages canvas rotation state and applies CSS transform
 */
import { useState, useEffect, RefObject } from 'react'

export function useCanvasRotation(canvasRef: RefObject<HTMLDivElement | null>) {
  const [rotation, setRotation] = useState(0)

  const handleRotate = () => {
    setRotation(prev => (prev + 90) % 360)
  }

  useEffect(() => {
    const canvasElement = canvasRef.current
    if (!canvasElement) return

    canvasElement.style.transform = `rotate(${rotation}deg)`
    canvasElement.style.transformOrigin = 'center center'
    canvasElement.style.transition = 'transform 0.3s ease'
  }, [rotation, canvasRef])

  return { rotation, handleRotate }
}
